import { Component } from "react";
import { Stack } from "@mui/material";
import ApuracaoPanel1 from "../ui/ApuracaoPanel1";
import DadosInventario from "../ui/DadosInventario";
import ApuracaoPanel2 from "../ui/ApuracaoPanel2";
import ApuracaoPanel3 from "../ui/ApuracaoPanel3";
import ApuracaoItensAjustados from "../ui/ApuracaoItensAjustados";
import ApuracaoVendas from "../ui/ApuracaoVendas";
import ApuracaoDepositos from "../ui/ApuracaoDepositos";
import { calcularDerivados } from "../util/apuracaoCalc.js";

export default class ApuracaoFicha extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        let { apuracao, loading, ajustes, onAjustarPainel, inicio, final } = this.props;

        // diferenças e itens ajustados são 100% derivados: apuracao (_ini, vindo do backend) + ajustes (state do pai)
        let { diferencas, itensAjustados } = calcularDerivados(apuracao, ajustes);

        return (
            <Stack gap={2}>
                <DadosInventario inicio={inicio} final={final} dados={apuracao?.info} loading={loading} disabled={apuracao.fechada} />

                <ApuracaoPanel1
                    nome="ESTOQUE PRINCIPAL" tipo="REL 302"
                    dados={apuracao?.principal} loading={loading} disabled={apuracao.fechada}
                    onAplicarAjuste={(ajuste) => onAjustarPainel('principal', ajuste)}
                />
                <ApuracaoPanel1
                    nome="ESTOQUE AVARIA" tipo="REL 302"
                    dados={apuracao?.avaria} loading={loading} disabled={apuracao.fechada}
                    onAplicarAjuste={(ajuste) => onAjustarPainel('avaria', ajuste)}
                />
                <ApuracaoPanel1
                    nome="AJUSTES MANUAIS" tipo="SECE112"
                    dados={apuracao?.ajustesManuais} loading={loading} disabled={apuracao.fechada}
                    onAplicarAjuste={(ajuste) => onAjustarPainel('ajustesManuais', ajuste)}
                />
                <ApuracaoPanel1
                    nome="AJUSTES POR DIVERGÊNCIA DO FORNECEDOR" tipo="SECE112"
                    dados={apuracao?.ajustesFornecedor} loading={loading} disabled={apuracao.fechada}
                    onAplicarAjuste={(ajuste) => onAjustarPainel('ajustesFornecedor', ajuste)}
                />
                <ApuracaoPanel1
                    nome="AJUSTES CONTAGEM SEMANAL" tipo="SECE112"
                    dados={apuracao?.ajustesSemanais} loading={loading} disabled={apuracao.fechada}
                    onAplicarAjuste={(ajuste) => onAjustarPainel('ajustesSemanais', ajuste)}
                />

                <ApuracaoPanel2 dados={apuracao?.nf} loading={loading} />
                <ApuracaoPanel3 dados={diferencas} loading={loading} />
                <ApuracaoItensAjustados dados={itensAjustados} loading={loading} />
                <ApuracaoDepositos tipo="SECE108" dados={apuracao?.depositos} loading={loading} />
                <ApuracaoVendas tipo="RFNF500" dados={apuracao?.vendas} loading={loading} />
            </Stack>
        );
    }
}
